import { render } from "./SearchItemSupplier.vue?vue&type=template&id=5d7ee890"
import script from "./SearchItemSupplier.vue?vue&type=script&lang=ts"
export * from "./SearchItemSupplier.vue?vue&type=script&lang=ts"
script.render = render

export default script